import React, { useState } from 'react';

import './StageNotify.scss';

const StageNotify = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="stage-notify">
      <svg
        className="stage-notify__close"
        onClick={() => setIsVisible(false)}
        width="800px"
        height="800px"
        viewBox="0 0 1024 1024"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#000000"
          d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
        />
      </svg>
      <div className="stage-notify__title">Attention</div>
      <div className="stage-notify__message">This is a staging environment</div>
    </div>
  );
};

export default StageNotify;
